
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recall",
      function () {
        return require("private-next-pages/recall.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recall"])
      });
    }
  